<template>
	<div id="app">
		<!-- 面包屑导航 -->
		<el-breadcrumb separator="/">
			<el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
			<el-breadcrumb-item><a href="/">家教管理</a></el-breadcrumb-item>
			<el-breadcrumb-item>家教列表</el-breadcrumb-item>
		</el-breadcrumb>

		<!-- 卡片视图区域 -->
		<el-card>
			<el-row :gutter="20">
				<el-col :span="4">
					<el-button type="primary" @click="addDialog = true">列表添加</el-button>
				</el-col>
			</el-row>

			<el-table :data="QicheList" border stripe>
				<el-table-column type="index" label="#"></el-table-column>
				<!-- <el-table-column label="汽车名称"> -->
				<el-table-column prop="img" label="封面图片">
					<template slot-scope="scope">
						<img :src="base + '/' +scope.row.img" alt="" style="width: 150px;height: 100px;">
					</template>
					<!-- </el-table-column> -->
				</el-table-column>
				<el-table-column prop="tel" label="电话"></el-table-column>
				<!-- <el-table-column prop="desc" label="描述"></el-table-column> -->
				<el-table-column prop="keywords" label="关键字"></el-table-column>
				<el-table-column prop="xueli" label="学历"></el-table-column>
				<el-table-column prop="username" label="姓名"></el-table-column>
				<el-table-column prop="zhengshu" label="授课时间"></el-table-column>

				<el-table-column prop="kemu" label="科目"></el-table-column>
				<el-table-column prop="quyu" label="区域"></el-table-column>
				<el-table-column prop="catename" label="分类名称"></el-table-column>

				<el-table-column label="操作" width="180px">
					<template slot-scope="scope">

						<el-button type="danger" icon="el-icon-delete" size="mini"
							@click="del(scope.row.id)"></el-button>

					</template>
				</el-table-column>

			</el-table>

			<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
				:page-sizes="[2, 4, 6, 8]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
				:total="total">
			</el-pagination>
		</el-card>

		<!-- 添加用户得对话框 -->
		<el-dialog title="家教添加" :visible.sync="addDialog" width="40%" @close="addDialogClosed">
			<span>
				<el-form ref="addFormRef" :model="addForm" label-width="70px">
					<el-upload class="upload-demo" :action="base+'/users/image'" multiple :limit="3"
						:on-success="successimg" :file-list="fileList">
						<el-button size="small" type="primary">点击上传</el-button>
						<div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过500kb</div>
					</el-upload>
					<el-form-item label="电话">
						<el-input v-model="addForm.tel"></el-input>
					</el-form-item>
					<el-form-item label="自我介绍">
						<el-input v-model="addForm.desc"></el-input>
					</el-form-item>
					<el-form-item label="所在院校">
						<el-input v-model="addForm.keywords"></el-input>
					</el-form-item>
					<el-form-item label="最高学历">
						<el-input v-model="addForm.xueli"></el-input>
					</el-form-item>
					<el-form-item label="姓名">
						<el-input v-model="addForm.username"></el-input>
					</el-form-item>
					<el-form-item label="所获证书">
						<el-input  v-model="addForm.zhengshu"></el-input>
					</el-form-item>
					<el-form-item label="经历优势(重点介绍)">
						<el-input v-model="addForm.jingli"></el-input>
					</el-form-item>
					<el-form-item label="科目">
						<el-input v-model="addForm.kemu"></el-input>
					</el-form-item>
					<el-form-item label="区域(建华铁锋龙沙)">
						<el-input v-model="addForm.quyu"></el-input>
					</el-form-item>
					<el-form-item label="分类名称">
						<el-select v-model="addForm.catename" placeholder="请选择分类名称">
							<el-option :label="item.catename" :value="item.catename" v-for="(item,index) in CateList"
								:key="index"></el-option>
						</el-select>
					</el-form-item>

				</el-form>
			</span>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addDialog = false">取 消</el-button>
				<el-button type="primary" @click="addQiche">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>

<script>
	import {
		getUserList,
		addUserList,
		selectUserList,
		editUserList,
		delUserList,
		Qicheadd,
		QicheList,
		Qichedel,
		CateList
	} from '@/api/index.js'
	import {
		BASE_URL
	} from '../../config.js'
	export default {
		data() {
			return {
				CateList: [],
				QicheList: [],
				selectUserObj: {},
				pageNum: 1,
				pageSize: 10,
				addForm: {
					tel: "",
					img: "",
					desc: "",
					keywords: "",
					xueli: "",
					username: "",
					zhengshu: "",
					jingli: "",
					kemu: "",
					quyu: "",
					catename: "",
				},
				editForm: {},
				addDialog: false,
				editDialog: false,
				total: 0,
				fileList: [],
				base: '',
				options: [{
				          value: '周一',
				          label: '周一'
				        }, {
				          value: '周二',
				          label: '周二'
				        }, {
				          value: '周三',
				          label: '周三'
				        }, {
				          value: '周四',
				          label: '周四'
				        }, {
				          value: '周五',
				          label: '周五'
				        },{
				          value: '周六',
				          label: '周六'
				        },{
				          value: '周日',
				          label: '周日'
				        }],
				        value: ''
			}
		},
		created() {
			this.getQicheList();
			this.base = BASE_URL;
			this.getCateList();
		},
		methods: {
			async getCateList() {
				const {
					data: res
				} = await CateList({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
				this.CateList = res.data.list;
				this.total = res.data.total;

				// console.log(this.userList);
			},
			async getQicheList() {
				const {
					data: res
				} = await QicheList({
					pageNum: this.pageNum,
					pageSize: this.pageSize,
				});
				console.log(res)
				this.QicheList = res.data.list;
				this.total = res.data.total;

				// console.log(this.userList);
			},
			handleSizeChange(newsize) {
				this.pageSize = newsize;
				this.getQicheList();
			},
			handleCurrentChange(newnum) {
				this.pageNum = newnum;
				this.getQicheList();
			},
			addDialogClosed() {
				this.addForm.username = "";
				this.addForm.password = "";
			},
			async addQiche() {
				//请求我的接口
				console.log(this.addForm);
				const {
					data: res
				} = await Qicheadd(this.addForm);
				if (res.code == 200) {
					this.$message.success('添加成功');
					this.getQicheList();
					this.addDialog = false;
				} else {
					this.$message.success('添加失败');
				}
			},
			async del(id) {
				const {
					data: res
				} = await Qichedel({
					id
				});
				if (res.code == 200) {
					this.$message.success('删除成功');
					this.getQicheList();
				} else {
					this.$message.success('删除失败');
				}
			},
			successimg(response) {
				console.log(response);
				this.addForm.img = response.pic;
			}

		}
	}
</script>
<style scoped>
	.el-card {
		margin-top: 20px;
	}

	.el-row {
		margin-bottom: 20px;
	}
</style>